module.exports = __webpack_public_path__ + "static/img/9.5280599.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/3/sp/9.png
// module id = /54F
// module chunks = 0